import { render, staticRenderFns } from "./ChicksStockList.vue?vue&type=template&id=122fab19&scoped=true&"
import script from "./ChicksStockList.vue?vue&type=script&lang=js&"
export * from "./ChicksStockList.vue?vue&type=script&lang=js&"
import style1 from "./ChicksStockList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122fab19",
  null
  
)

export default component.exports